import React from "react";
import classes from "./DescriptorFact.module.scss";
import { Fact } from "../../routes/BookConfirm";

interface Props {
  fact: Fact;
}

function DescriptorFact({ fact }: Props) {
  return (
    <div className={classes.fact}>
      <span className={classes.icon}>{fact.icon}</span>
      <span className={classes.text}>{fact.text}</span>
    </div>
  );
}

export default DescriptorFact;
